import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VisitorStatisticsList from './components/VisitorStatisticsList';

const { Cell } = ResponsiveGrid;

const VisitorStatistics = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客統計"
        // description="訪客列表"
        breadcrumbs={[
          {
            name: '訪客管理',
          },
          {
            name: '訪客統計',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VisitorStatisticsList />
    </Cell>
  </ResponsiveGrid>
);

export default VisitorStatistics;
